import React from 'react';
import { BaseButton, ButtonSize, NativeButtonProps } from './BaseButton';

type Props = NativeButtonProps & {
  size?: ButtonSize;
  stretch?: boolean;
};

export const SecondaryButton = (props: Props) => <BaseButton buttonStyle="secondary" {...props} />;
